import { createElement, useReducer } from 'react';
import { isBrowser } from '../utils';
import { App_Context as Context } from './create-context';
import { getReqCtx } from '../store/client/internal';
// 客户端的 context  只需要创建一次，在页面整个生命周期内共享
function defaultReducer(state, action) {
    switch (action.type) {
        case 'updateContext':
            if (process.env.NODE_ENV !== 'production') {
                console.log('[SSR:updateContext]: dispatch updateContext with action');
                console.log(action);
            }
            return { ...state, ...action.payload };
        default:
            break;
    }
}
const initialState = {
    layoutData: {
        ...(isBrowser ? window.__LAYOUT_DATA__ || {} : {}),
    },
    pageData: {
        ...(isBrowser ? window.__PAGE_DATA__ || {} : {}),
    },
};
const combineReducer = (userReducer) => (state, action) => {
    return defaultReducer(state, action) || userReducer(state, action);
};
export function AppContextComponent(props) {
    const { children, reducer = (state) => state } = props;
    const [state, dispatch] = useReducer(combineReducer(reducer), initialState);
    const ctx = getReqCtx();
    return createElement(Context.Provider, {
        value: {
            state,
            dispatch,
            ctx,
        },
    }, children);
}
